import { EditorState, Plugin } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';

import { RtPMPlugin } from '../../editor/types';

interface EmojiSupportServiceWysiwyg {
  fallbackRegex: RegExp | null;
  getFallbackImgUrl: (emoji: string) => string | null;
}

export class EmojiViewPlugin implements RtPMPlugin {
  private emojiFallbackPlugin = new Plugin({
    state: {
      init: (config: any, instance: EditorState): DecorationSet | null =>
        this.getEmojiFallbackDecorations(instance),
      apply: (tr, set, oldState, currentState): DecorationSet | null => {
        if (!tr.docChanged) return set;

        return this.getEmojiFallbackDecorations(currentState);
      },
    },
    props: {
      decorations: state => (<any>this).emojiFallbackPlugin.getState(state),
    },
  });

  constructor(private emojiSupportService: EmojiSupportServiceWysiwyg) {}

  public getNativeViewPlugins() {
    return [this.emojiFallbackPlugin];
  }

  private getEmojiFallbackDecorations(state: EditorState): DecorationSet | null {
    const matches: { pos: number; match: RegExpMatchArray }[] = [];
    const { fallbackRegex } = this.emojiSupportService;

    if (!fallbackRegex) return null;

    state.doc.descendants((node, pos, parent) => {
      if (node.isText) {
        let match;
        while ((match = fallbackRegex.exec(node.text!))) matches.push({ pos, match });

        return false;
      }

      return true;
    });

    return DecorationSet.create(
      state.doc,
      <Decoration[]>matches
        .map(({ pos, match }) => {
          const emojiSize = match[0].length;
          const from = pos + match.index!;
          const to = from + emojiSize;
          const fallbackUrl = this.emojiSupportService.getFallbackImgUrl(match[0]);

          return fallbackUrl
            ? Decoration.inline(from, to, {
                class: 'emoji-fallback',
                style: `background-image: url('${fallbackUrl}')`,
              })
            : null;
        })
        .filter(Boolean),
    );
  }
}
